import { compact, uniq } from 'lodash'
import { useEffect } from 'react'
import { useSmsAgentOps } from 'app/components/ai-agent-sms-ops/useSmsAgentOps'
import { useSmsAgentOpsStore } from 'app/stores/StoreContext'

/**
 * The SMS Ops store's live lists for the page's scope, plus the AI texts, and the four counts
 * built from them. Shared by the SMS dashboard and the Overview card. Callers are observers.
 */
export function useSmsLiveStats() {
  const ops = useSmsAgentOps()
  const store = useSmsAgentOpsStore()
  const { fromDate, toDate } = ops

  useEffect(() => {
    store.loadAiTexts()
  }, [store, fromDate, toDate, store.locationIds, store.orgId])

  const { aiTexts, takeovers, optOuts } = store
  const count = (label: string, value: number | undefined, message: string) => ({
    label,
    value: (value ?? 0).toLocaleString(`en-US`),
    infoTooltip: { title: label, message },
  })
  return {
    ops,
    store,
    isLoading: [aiTexts, takeovers, optOuts].some((list) => list === undefined),
    stats: [
      count(
        `AI Conversations`,
        aiTexts && uniq(compact(aiTexts.map((text) => text.threadId))).length,
        `Threads the AI agent texted in the date range.`,
      ),
      count(`AI Texts`, aiTexts?.length, `Texts the AI agent sent in the date range.`),
      count(`Takeovers`, takeovers?.length, `Times staff took a thread over from the AI agent.`),
      count(`Opt-Outs`, optOuts?.length, `Numbers that opted out of texts in the date range.`),
    ],
  }
}
